import React, { useState, useEffect } from 'react';
import { FaqsCategory } from '../../pages';
import { toJS } from 'mobx';
import { SupportController } from '../../controllers';
import { supportStore } from '../../stores';

const FaqsCategoryContainer = () => {
    const [loading, setLoading] = useState(false);
    const [addCategoryModal, setAddCategoryModal] = useState(false);
    const [editCategoryModal, setEditCategoryModal] = useState(false);
    const [deleteCategoryModal, setDeleteCategoryModal] = useState(false);

    useEffect(() => {
        setLoading(true)
        const getFaqDetails = async () => {
            await SupportController.getFaqs();
            setLoading(false);
        }
        getFaqDetails();
    }, [])
    

    const goToAddCategoryModal = () => {
        setAddCategoryModal(true);
    }
    const goToEditCategoryModal = () => {
        setEditCategoryModal(true);
    }
    const goToDeleteCategoryModal = () => {
        setDeleteCategoryModal(true);
    }

    const closeModal = () => {
        setAddCategoryModal(false);
        setEditCategoryModal(false);
        setDeleteCategoryModal(false);
    }

    return (
        <FaqsCategory
            goToDeleteCategoryModal={goToDeleteCategoryModal}
            deleteCategoryModal={deleteCategoryModal}
            goToAddCategoryModal={goToAddCategoryModal}
            addCategoryModal={addCategoryModal}
            goToEditCategoryModal={goToEditCategoryModal}
            editCategoryModal={editCategoryModal}
            loading={loading}
            closeModal={closeModal}    
            faqsCategory={toJS(supportStore.faqs)}         
        />
    )
}
export default FaqsCategoryContainer;